import { EnterpriseNoticesV1NaptimeResource } from './__generated__/EnterpriseNoticesV1';

class EnterpriseNotices extends EnterpriseNoticesV1NaptimeResource {
  static RESOURCE_NAME = 'enterpriseNotices.v1' as const;
}

export default EnterpriseNotices;
